import { ReactNode, useEffect } from 'react';
import { useLocation } from 'wouter';
import { useAuthProvider } from '../../hooks/use-azure-auth-provider';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isSignedIn, isLoaded } = useAuthProvider();
  const [, navigate] = useLocation();
  
  // Add effect to handle redirection when authentication state changes
  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      // Redirect to welcome page when not authenticated
      navigate("/welcome");
    }
  }, [isLoaded, isSignedIn, navigate]);

  // While still loading auth state, show loading indicator
  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mb-4"></div>
          <p className="text-gray-500">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  // If not signed in, show the redirecting message
  if (!isSignedIn) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="flex flex-col items-center">
          <p className="text-gray-500">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  // If signed in, render the protected content
  return <>{children}</>;
}